const getErrorKey = (fieldName, errorPrefix) => (fieldName && fieldName.trim().length > 0
  ? `${errorPrefix}.${fieldName.trim()}`
  : errorPrefix);

export default getErrorKey;
